import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { cn } from '@tempo-io/sui-class-utils';
import { DragIndicator } from '@tempo-io/sui-icons';
import { useMemo } from 'react';
import type { ISwimlaneHeaderProps } from '@/lib/api/types/loop-visualization';

interface SortableHeaderItemProps {
  header: ISwimlaneHeaderProps;
  index: number;
}

export const SortableHeaderItem = ({ header, index }: SortableHeaderItemProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: header.id,
  });

  const style = useMemo(
    () => ({
      transform: CSS.Translate.toString(transform),
      transition,
      opacity: isDragging ? 0.6 : 1,
      zIndex: isDragging ? 1 : 0,
      position: 'relative' as const,
    }),
    [transform, transition, isDragging],
  );

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center gap-3 p-3 bg-bg-surface-base border border-border-neutral-subtle rounded-md mb-2 hover:bg-bg-neutral-subtle-hovered"
    >
      <div
        {...attributes}
        {...listeners}
        className={cn('text-icon-neutral-primary', {
          'cursor-grab': !isDragging,
          'cursor-grabbing': isDragging,
        })}
      >
        <DragIndicator size={20} />
      </div>
      <span className="flex-1 text-sm font-medium">{header.label || `Header ${index + 1}`}</span>
    </div>
  );
};
